import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, computed, onMounted } from "vue";
import NextStepCoaching from '@/guiide/components/dboptions/NextStepCoaching.vue';
import NextStepIFA from "@/guiide/components/dboptions/NextStepIFA.vue";
import SummaryRadioGroup from "@/guiide/components/common/SummaryRadioGroup.vue";
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

    type OptionInfo = {
        type: FinalSalaryNextSteps;
        name: string;
        description: Array<string>;
        icon: string;
        abbreviation: string;
    };

    enum FinalSalaryNextSteps {
        Coaching,
        IFA,
        NotReadyToRetire,
        NeedMoreSupport,
        ReadyToRetire
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FinalSalarySchemeSupport',
  props: {
        schemeSupportMode: { type: String, required: true }
    },
  setup(__props) {

const { htmlArray, bool } = useUIContent();

    const props = __props;

    onMounted(() => {
        selectedOption.value = options.value.length > 0 ? options.value[0].type : FinalSalaryNextSteps.ReadyToRetire;
    });

    const hasCoachingOption = props.schemeSupportMode === "Coaching";
    const hasIFAOption = props.schemeSupportMode == "IFA";

    const selectedOption = ref<FinalSalaryNextSteps>(FinalSalaryNextSteps.ReadyToRetire);

    const options = computed<Array<OptionInfo>>(() => {

        const includeIFA = props.schemeSupportMode == "IFA";
        const includeCoaching = props.schemeSupportMode == "Coaching";
        const includeNotReadyToRetire = bool('dboptions.next-steps.not-ready-to-retire.enabled');
        const includeNeedMoreSupport = bool('dboptions.next-steps.need-more-support.enabled');
        const includeReadyToRetire = bool('dboptions.next-steps.ready-to-retire.enabled');

        const optionsArray = new Array<OptionInfo>();

        if (includeIFA) {
            optionsArray.push({
                type: FinalSalaryNextSteps.IFA,
                name: "I need support with my options",
                description: [""],
                icon: "bi bi-chat-right-text",
                abbreviation: ""
            });
        }

        if (includeCoaching) {
            optionsArray.push({
                type: FinalSalaryNextSteps.Coaching,
                name: "I need support with my options",
                description: [""],
                icon: "bi-mortarboard",
                abbreviation: ""
            });
        }

        if (includeNotReadyToRetire) {
            const description = htmlArray('dboptions.next-steps.not-ready-to-retire.text');
            optionsArray.push({
                type: FinalSalaryNextSteps.NotReadyToRetire,
                name: "I'm not ready to retire yet",
                description,
                icon: "bi-hourglass-split",
                abbreviation: ""
            });
        }

        if (includeNeedMoreSupport) {
            const description = htmlArray('dboptions.next-steps.need-more-support.text');
            optionsArray.push({
                type: FinalSalaryNextSteps.NeedMoreSupport,
                name: "I need more support",
                description,
                icon: "bi-person-raised-hand",
                abbreviation: ""
            });
        }

        if (includeReadyToRetire) {
            const description = htmlArray('dboptions.next-steps.ready-to-retire.text');
            optionsArray.push({
                type: FinalSalaryNextSteps.ReadyToRetire,
                name: "I'm ready to retire",
                description,
                icon: "bi-piggy-bank",
                abbreviation: ""
            });
        }

        return optionsArray;
    });


return (_ctx: any,_cache: any) => {
  return (options.value.length)
    ? (_openBlock(), _createBlock(SummaryRadioGroup, {
        key: 0,
        modelValue: selectedOption.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOption).value = $event)),
        options: options.value
      }, {
        extraContent: _withCtx(({ selected }) => [
          (selectedOption.value === FinalSalaryNextSteps.Coaching && hasCoachingOption)
            ? (_openBlock(), _createBlock(NextStepCoaching, { key: 0 }))
            : _createCommentVNode("", true),
          (selectedOption.value === FinalSalaryNextSteps.IFA && hasIFAOption)
            ? (_openBlock(), _createBlock(NextStepIFA, { key: 1 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "options"]))
    : _createCommentVNode("", true)
}
}

})